import { frontendURL } from '../../../helper/URLHelper';
import OuroborosMetrics from './pages/RelatorioDashBoardMetricas.vue';
import OuroborosTables from './pages/RelatorioDashboardTabelas.vue';

const commonMeta = {
  permissions: ['administrator', 'manager', 'agent'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/reports/ouroboros/metrics'),
    component: OuroborosMetrics,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'ouroboros_metrics',
        component: OuroborosMetrics,
        meta: commonMeta,
      },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/reports/ouroboros/tables'),
    component: OuroborosTables,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'ouroboros_tables',
        component: OuroborosTables,
        meta: commonMeta,
      },
    ],
  },
];
